import { useRouteError } from 'react-router-dom';

import Spinner from '~/common/components/utils/Spinner';
import { interruptWith, isProductionChunkError } from '~/common/utils/error.util.tsx';

function RootBoundary() {
  const error = useRouteError();

  // ? 실제 운영 환경에서만 chunk 오류를 loader fallback 으로 처리
  if (isProductionChunkError(error)) {
    return <Spinner fullScreen />;
  }

  // ? 에러 페이지 렌더링 위임
  return interruptWith(error);
}

export default RootBoundary;
